var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 21.306,
    viewBox: "0 0 17.083 21.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-report",
    transform: "translate(-35 -402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M20.2,0H11.251A2.87,2.87,0,0,0,8.384,2.867V18.438a2.87,2.87,0,0,0,2.867,2.867H22.6a2.87,2.87,0,0,0,2.867-2.867V5.891Zm.418,2.733,2.408,2.691H20.613V2.733ZM22.6,19.794H11.251A1.357,1.357,0,0,1,9.9,18.438V2.867a1.357,1.357,0,0,1,1.356-1.356H19.1V6.935h4.853v11.5A1.358,1.358,0,0,1,22.6,19.794Z",
    transform: "translate(26.616 402)",
    fill: "#45338c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 10.816,
    height: 1.511,
    transform: "translate(38.133 417.274)",
    fill: "#45338c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 10.816,
    height: 1.511,
    transform: "translate(38.133 413.99)",
    fill: "#45338c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 10.816,
    height: 1.511,
    transform: "translate(38.133 410.708)",
    fill: "#45338c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.90cea52e4452a9b1599db2fd212ff39d.svg";
export { ForwardRef as ReactComponent };